import { getBaseUrl, getApiDomain } from "@/utils/api.config.js";
import { actions as authActions } from "@/app/auth";
import axios from "axios";

const baseUrl = getBaseUrl();
const apiDomain = getApiDomain();

export const core = {
  API: (
    method,
    url,
    baseType,
    commitType,
    rollbackType,
    data,
    metaArg = null,
    isClientToken
  ) => {
    const headers = {
      "Cache-Control": "no-cache",
      Accept: "*/*",
      Authorization: `Bearer ${
        authActions.isLoggedIn() && !isClientToken
          ? authActions.getAccessToken()
          : import.meta.env.VITE_AUTHORIZED_CLIENT_TOKEN
      }`,
    };

    const dataOrParams = ["GET", "DELETE"].includes(method) ? "params" : "data";

    return (dispatch) => {
      if (baseType) {
        dispatch({ type: baseType });
      }

      axios
        .request({
          url: `${baseUrl}${url}`,
          method,
          headers,
          [dataOrParams]: data,
        })
        .then(({ data }) => {
          dispatch({ type: commitType, meta: metaArg, payload: data });
        })
        .catch((error) => {
          let errorObj = error;
          if (error.response) {
            errorObj = {
              status: error.response.status || "Error",
              response: error.response.data || {},
              name: error.response.statusText || "",
            };
          }
          dispatch({ type: rollbackType, payload: errorObj });
        });
    };
  },
  API2: (
    method,
    url,
    baseType,
    commitType,
    rollbackType,
    data,
    metaArg = null,
    isClientToken
  ) => {
    const headers = {
      "Cache-Control": "no-cache",
      Accept: "*/*",
      Authorization: `Bearer ${
        authActions.isLoggedIn() && !isClientToken
          ? authActions.getAccessToken()
          : import.meta.env.VITE_AUTHORIZED_CLIENT_TOKEN
      }`,
    };

    const dataOrParams = ["GET", "DELETE"].includes(method) ? "params" : "data";

    return (dispatch) => {
      if (baseType) {
        dispatch({ type: baseType });
      }

      axios
        .request({
          url: `${apiDomain}${url}`,
          method,
          headers,
          [dataOrParams]: data,
        })
        .then(({ data }) => {
          dispatch({ type: commitType, meta: metaArg, payload: data });
        })
        .catch((error) => {
          let errorObj = error;
          if (error.response) {
            errorObj = {
              status: error.response.status || "Error",
              response: error.response.data || {},
              name: error.response.statusText || "",
            };
          }
          dispatch({ type: rollbackType, payload: errorObj });
        });
    };
  },
};

// ------------------ Mock data feature --------------------------

let mockingEnabled = false;

let mocks = {};

export function addMock(url, data) {
  const fullURL = `${baseUrl}${url}`;
  mocks[fullURL] = data;
}

export function enableMocking(mockData) {
  mockingEnabled = true;
  mockData.forEach((url) => {
    addMock(url.path, url.payload);
  });
}

export function disableMocking() {
  mockingEnabled = false;
  mocks = {};
}

export function removeMocking() {
  // disable interceptor
  axios.interceptors.request.eject(mockInterceptor);
}

const isUrlMocked = (url) => {
  const matchURL = url.split("?")[0];
  return matchURL in mocks;
};

const getMockError = (config) => {
  const mockError = new Error();
  const matchURL = config.url.split("?")[0];
  mockError.mockData = mocks[matchURL];
  mockError.config = config;
  return Promise.reject(mockError);
};

const isMockError = (error) => Boolean(error.mockData);

const getMockResponse = (mockError) => {
  const { mockData, config } = mockError;
  // Handle mocked error (any non-2xx status code)
  if (mockData.status && String(mockData.status)[0] !== "2") {
    const err = new Error(mockData.message || "mock error");
    err.code = mockData.status;
    return Promise.reject(err);
  }
  // Handle mocked success
  return Promise.resolve(
    Object.assign(
      {
        data: {},
        status: 200,
        statusText: "OK",
        headers: {},
        config,
        isMock: true,
      },
      mockData
    )
  );
};

// Add a request interceptor
const mockInterceptor = axios.interceptors.request.use(
  (config) => {
    if (mockingEnabled && isUrlMocked(config.url)) {
      return getMockError(config);
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Add a response interceptor
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (isMockError(error)) {
      return getMockResponse(error);
    }
    return Promise.reject(error);
  }
);
